var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn text-left outline-dark border-0 ",on:{"click":function($event){return _vm.getMediaUrl()}}},[_c('span',{class:_vm.iconClass},[_vm._v(" ")]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }